import React from 'react';

import Sessions from 'Services/Api/MainStage/Sessions';
import {resourceDateIsBeforeNow, resourceDateIsAfterNow} from 'Services/DateHelpers';
import {Toast, Socket, User} from 'Services';

export default class Base extends React.Component {
    /**
     * @method mountBase
     */
    mountBase = () => {
        this.fetchSessions();

        this.subscribeToBroadcasts();

        this.interval = setInterval(this.updateSessions, 2000); // 2 seconds
    }

    /**
     * @method unmountBase
     */
    unmountBase = () => {
        Socket.getConnection().leave('main_stage_sessions');

        window.clearInterval(this.interval);
    }

    /**
     * @method subscribeToBroadcasts
     */
    subscribeToBroadcasts = () => {
        Socket.getConnection()
            .private(`main_stage_sessions`)
            .listen('MainStageSessionsUpdated', (e) => {
                const { sessions } = this.state;

                if (sessions) {
                    const i = sessions?.map(s => s.id).indexOf(e.session.id);

                    if (i !== -1) {
                        this.setState({
                            sessions: sessions.map(s => {
                                if (s.id === e.session.id) {
                                    return e.session;
                                }

                                return s;
                            }),
                        });

                        return;
                    }
                }

                this.fetchSessions(false);
            })
            .listen('MainStageSessionsDeleted', (e) => {
                const { sessions } = this.state;

                this.setState({
                    sessions: sessions.filter(s => s.id !== e.session.id)
                });
            })
            .listen('MainStagePollsUpdated', (e) => this.fetchSessions(false));
    }

    /**
     * @method updateSessions
     */
    updateSessions = () => {
        const currentSession = this.state.sessions.find(session => {
            return resourceDateIsBeforeNow(session.starts_at) && (session.ends_at === null || resourceDateIsAfterNow(session.ends_at))
        });

        if (
            currentSession
        ) {
            const state = this.state;
            let updated = false;

            if ((currentSession.id !== this.state.currentSession?.id || currentSession.updated_at?.iso_string !== this.state.currentSession.updated_at?.iso_string)) {
                state.currentSession = currentSession;
                updated = true;
            }

            // Current Poll
            if (currentSession.polls.length > 0) {
                // Display the last poll available
                let polls = currentSession.polls.filter(poll => resourceDateIsBeforeNow(poll.display_from));

                state.currentPoll = polls[polls.length - 1];

                updated = true;
            }

            if (updated) {
                this.setState(state);
            }
        } else if (!currentSession && this.state.currentSession) {
            this.setState({
                currentSession: null,
                currentPoll: null,
            });
        }
    };

    /**
     * @method fetchSessions
     * @param {boolean} initialLoad
     * @return {Promise<void>}
     */
    fetchSessions = async (initialLoad = true) => {
        if (initialLoad) {
            this.setState({working: true});
        }

        let params = {
            live_and_upcoming_sessions: 1,
            my_language: 1
        };

        if (this.remote_control) {
            params.remote_control = 1;
        }

        const request = await Sessions.get(null, params);

        if (request.success) {
            return this.setState({
                sessions: request.data.data,
                working: false,
            }, this.updateSessions);
        }

        Toast.error();
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        return null;
    }
}
